

function RegisterVisual(props:any) {
    return (
      <div className="product-visual-register">
        <h2>{props.title}</h2>
      </div>
    );
}
export default RegisterVisual;
  